import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ChatBotHero from "./components/ChatBotHero";
import ChatBotServices from "./components/ChatBotServices";
import ChatBotFeatures from "./components/ChatBotFeatures";
import ChatBotWhyChoose from "./components/ChatBotWhyChoose";
import ChatBotProcess from "./components/ChatBotProcess";
import ChatBotUseCases from "./components/ChatBotUseCases";
import ChatBotSuccessStories from "./components/ChatBotSuccessStories";
import ChatBotIntegrations from "./components/ChatBotIntegrations";
import ChatBotTestimonials from "./components/ChatBotTestimonials";
import ChatBotFaq from "./components/ChatBotFaq";
import ChatBotCta from "./components/ChatBotCta";
import "./chat-bot.css";

const ChatBotPage: React.FC = () => {
  useEffect(() => {
    document.title = "AI Chatbot Development Services | WebTech Bangalore";

    const description =
      "Build intelligent AI chatbots for customer support, lead generation, and workflow automation. Premium chatbot development by WebTech.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="cbot-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <ChatBotHero />
            <ChatBotServices />
            <ChatBotFeatures />
            <ChatBotWhyChoose />
            <ChatBotProcess />
            <ChatBotUseCases />
            <ChatBotSuccessStories />
            <ChatBotIntegrations />
            <ChatBotTestimonials />
            <ChatBotFaq />
            <ChatBotCta />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ChatBotPage;
